__turbopack_context__.v({
  "bgWhite": "JourneyMap-module__4EfcKq__bgWhite",
  "buttonContent": "JourneyMap-module__4EfcKq__buttonContent",
  "container": "JourneyMap-module__4EfcKq__container",
  "content": "JourneyMap-module__4EfcKq__content",
  "dateRange": "JourneyMap-module__4EfcKq__dateRange",
  "endCircle": "JourneyMap-module__4EfcKq__endCircle",
  "forceMobile": "JourneyMap-module__4EfcKq__forceMobile",
  "heading": "JourneyMap-module__4EfcKq__heading",
  "itemDetails": "JourneyMap-module__4EfcKq__itemDetails",
  "itemTitle": "JourneyMap-module__4EfcKq__itemTitle",
  "jgSpacing": "JourneyMap-module__4EfcKq__jgSpacing",
  "mapContainer": "JourneyMap-module__4EfcKq__mapContainer",
  "mapLoading": "JourneyMap-module__4EfcKq__mapLoading",
  "nonEssenceCircle": "JourneyMap-module__4EfcKq__nonEssenceCircle",
  "originCircle": "JourneyMap-module__4EfcKq__originCircle",
  "overviewAdjusterWrapper": "JourneyMap-module__4EfcKq__overviewAdjusterWrapper",
  "overviewContainer": "JourneyMap-module__4EfcKq__overviewContainer",
  "overviewContent": "JourneyMap-module__4EfcKq__overviewContent",
  "overviewHeader": "JourneyMap-module__4EfcKq__overviewHeader",
  "overviewItem": "JourneyMap-module__4EfcKq__overviewItem",
  "overviewList": "JourneyMap-module__4EfcKq__overviewList",
  "overviewTitle": "JourneyMap-module__4EfcKq__overviewTitle",
  "positionText": "JourneyMap-module__4EfcKq__positionText",
  "reverseOrder": "JourneyMap-module__4EfcKq__reverseOrder",
  "stayCircle": "JourneyMap-module__4EfcKq__stayCircle",
  "stopCircle": "JourneyMap-module__4EfcKq__stopCircle",
  "timelineIconCircle": "JourneyMap-module__4EfcKq__timelineIconCircle",
  "timelineLine": "JourneyMap-module__4EfcKq__timelineLine",
  "underline": "JourneyMap-module__4EfcKq__underline",
});
